export default __webpack_public_path__ + "static/media/spotlight-base.fe84c2e7.svg";